// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var JsxRuntime = require("react/jsx-runtime");
var ImportEnrichmentRuleTypes$ReactHooksTemplate = require("./ImportEnrichmentRuleTypes.res.js");
var ImportEnrichmentFieldPicker$ReactHooksTemplate = require("./ImportEnrichmentFieldPicker.res.js");
var ImportEnrichmentActionStyles$ReactHooksTemplate = require("./ImportEnrichmentActionStyles.res.js");
var ImportEnrichmentActionHelpers$ReactHooksTemplate = require("./ImportEnrichmentActionHelpers.res.js");
var ImportEnrichmentExtractBuilder$ReactHooksTemplate = require("./ImportEnrichmentExtractBuilder.res.js");
var ImportEnrichmentTemplateBuilder$ReactHooksTemplate = require("./ImportEnrichmentTemplateBuilder.res.js");
var ImportEnrichmentLookupMappingBuilder$ReactHooksTemplate = require("./ImportEnrichmentLookupMappingBuilder.res.js");

function transformCardClass(selected) {
  return "text-left rounded-lg border px-3 py-2 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-blue-500 " + (
          selected ? "border-lochmara bg-aliceblue ring-1 ring-lochmara" : "border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50"
        );
}

function methodCardClass(selected) {
  return "w-full text-left rounded-lg border px-3 py-3 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-blue-500 " + (
          selected ? "border-lochmara bg-aliceblue ring-1 ring-lochmara" : "border-gray-200 bg-white hover:border-gray-300 hover:bg-gray-50"
        );
}

function ImportEnrichmentActionForm$MethodCard(props) {
  var onSelect = props.onSelect;
  var selected = props.selected;
  return JsxRuntime.jsxs("button", {
              children: [
                JsxRuntime.jsx("span", {
                      children: props.title,
                      className: "block text-sm font-semibold text-gray-900"
                    }),
                JsxRuntime.jsx("span", {
                      children: props.description,
                      className: "block text-xs text-gray-500 mt-1 leading-snug"
                    })
              ],
              "aria-checked": selected ? "true" : "false",
              className: methodCardClass(selected),
              role: "radio",
              name: props.name,
              type: "button",
              onClick: (function (param) {
                  Curry._1(onSelect, undefined);
                })
            });
}

var MethodCard = {
  make: ImportEnrichmentActionForm$MethodCard
};

function ImportEnrichmentActionForm$TransformMethodCard(props) {
  var __deemphasized = props.deemphasized;
  var onSelect = props.onSelect;
  var selected = props.selected;
  var valueType = props.valueType;
  var deemphasized = __deemphasized !== undefined ? __deemphasized : false;
  return JsxRuntime.jsxs("button", {
              children: [
                JsxRuntime.jsx("span", {
                      children: ImportEnrichmentRuleTypes$ReactHooksTemplate.valueTypeLabel(valueType),
                      className: "block text-xs font-semibold text-gray-900"
                    }),
                JsxRuntime.jsx("span", {
                      children: ImportEnrichmentRuleTypes$ReactHooksTemplate.valueTypeDescription(valueType),
                      className: "block text-xs text-gray-500 mt-0.5 leading-snug"
                    })
              ],
              "aria-checked": selected ? "true" : "false",
              className: transformCardClass(selected) + (
                deemphasized ? " opacity-90" : ""
              ),
              role: "radio",
              name: props.name,
              type: "button",
              onClick: (function (param) {
                  Curry._1(onSelect, valueType);
                })
            });
}

var TransformMethodCard = {
  make: ImportEnrichmentActionForm$TransformMethodCard
};

function ImportEnrichmentActionForm$TransformMethodPicker(props) {
  var title = props.title;
  var groupName = props.groupName;
  var onSelect = props.onSelect;
  var fieldOptions = props.fieldOptions;
  var row = props.row;
  var dataType = ImportEnrichmentActionHelpers$ReactHooksTemplate.targetDataType(fieldOptions, row.targetKind, row.targetField);
  var match = ImportEnrichmentActionHelpers$ReactHooksTemplate.partitionTransformMethods(dataType, row.valueType, ImportEnrichmentActionHelpers$ReactHooksTemplate.transformMethods);
  var otherMethods = match[1];
  var match$1 = React.useState(function (param) {
        return Belt_List.some(otherMethods, (function (method) {
                      return method === row.valueType;
                    }));
      });
  var setOtherOpen = match$1[1];
  var otherOpen = match$1[0];
  var uncommonHint = ImportEnrichmentActionHelpers$ReactHooksTemplate.uncommonMethodMessage(fieldOptions, row.targetKind, row.targetField, row.valueType);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("p", {
                      children: title,
                      className: "text-sm font-medium text-gray-700 mb-2"
                    }),
                JsxRuntime.jsx("div", {
                      children: $$Array.of_list(Belt_List.map(match[0], (function (valueType) {
                                  return JsxRuntime.jsx(ImportEnrichmentActionForm$TransformMethodCard, {
                                              valueType: valueType,
                                              selected: row.valueType === valueType,
                                              onSelect: onSelect,
                                              name: groupName
                                            }, ImportEnrichmentRuleTypes$ReactHooksTemplate.valueTypeToString(valueType));
                                }))),
                      "aria-label": title,
                      className: "grid grid-cols-1 sm:grid-cols-2 gap-2",
                      role: "radiogroup"
                    }),
                Belt_List.length(otherMethods) > 0 ? JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("button", {
                                children: otherOpen ? "▾ Other transforms" : "▸ Other transforms",
                                "aria-label": "Toggle other transform methods",
                                "aria-expanded": otherOpen,
                                className: "text-sm font-medium text-gray-600 hover:text-gray-900 focus:outline-none focus:underline",
                                type: "button",
                                onClick: (function (param) {
                                    Curry._1(setOtherOpen, (function (prev) {
                                            return !prev;
                                          }));
                                  })
                              }),
                          otherOpen ? JsxRuntime.jsx("div", {
                                  children: $$Array.of_list(Belt_List.map(otherMethods, (function (valueType) {
                                              return JsxRuntime.jsx(ImportEnrichmentActionForm$TransformMethodCard, {
                                                          valueType: valueType,
                                                          selected: row.valueType === valueType,
                                                          onSelect: onSelect,
                                                          name: groupName + "-other",
                                                          deemphasized: true
                                                        }, ImportEnrichmentRuleTypes$ReactHooksTemplate.valueTypeToString(valueType));
                                            }))),
                                  "aria-label": "Other transform methods",
                                  className: "mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2",
                                  role: "radiogroup"
                                }) : null
                        ],
                        className: "mt-3"
                      }) : null,
                uncommonHint !== undefined ? JsxRuntime.jsx("p", {
                        children: uncommonHint,
                        className: ImportEnrichmentActionStyles$ReactHooksTemplate.validationWarningClass
                      }) : null
              ]
            });
}

var TransformMethodPicker = {
  make: ImportEnrichmentActionForm$TransformMethodPicker
};

function ImportEnrichmentActionForm$MethodInputs(props) {
  var onUpdate = props.onUpdate;
  var simulationInputs = props.simulationInputs;
  var fieldOptions = props.fieldOptions;
  var row = props.row;
  var value = Js_dict.get(simulationInputs, row.regexPath);
  var regexSample = value !== undefined ? value : undefined;
  var renderLiteralInput = function (param) {
    var inputKind = ImportEnrichmentActionHelpers$ReactHooksTemplate.literalInputKindForTarget(fieldOptions, row.targetKind, row.targetField);
    if (typeof inputKind === "object") {
      if (inputKind.TAG === "ListLiteral") {
        return JsxRuntime.jsxs("select", {
                    children: [
                      JsxRuntime.jsx("option", {
                            children: "Choose a value",
                            value: ""
                          }),
                      Belt_Array.map(inputKind._0, (function (option) {
                              return JsxRuntime.jsx("option", {
                                          children: option,
                                          value: option
                                        }, option);
                            }))
                    ],
                    className: ImportEnrichmentActionStyles$ReactHooksTemplate.selectBase,
                    value: row.valueLiteral,
                    onChange: (function (e) {
                        var newrecord = Caml_obj.obj_dup(row);
                        Curry._1(onUpdate, (newrecord.valueLiteral = e.target.value, newrecord));
                      })
                  });
      } else {
        return JsxRuntime.jsxs("select", {
                    children: [
                      JsxRuntime.jsx("option", {
                            children: "Choose yes or no",
                            value: ""
                          }),
                      Belt_Array.map(inputKind._0, (function (option) {
                              return JsxRuntime.jsx("option", {
                                          children: option,
                                          value: option
                                        }, option);
                            }))
                    ],
                    className: ImportEnrichmentActionStyles$ReactHooksTemplate.selectBase,
                    value: row.valueLiteral,
                    onChange: (function (e) {
                        var newrecord = Caml_obj.obj_dup(row);
                        Curry._1(onUpdate, (newrecord.valueLiteral = e.target.value, newrecord));
                      })
                  });
      }
    }
    switch (inputKind) {
      case "TextLiteral" :
          return JsxRuntime.jsx("input", {
                      className: ImportEnrichmentActionStyles$ReactHooksTemplate.inputBase,
                      placeholder: "e.g. Email, Phone, or any text for this field",
                      value: row.valueLiteral,
                      onChange: (function (e) {
                          var newrecord = Caml_obj.obj_dup(row);
                          Curry._1(onUpdate, (newrecord.valueLiteral = e.target.value, newrecord));
                        })
                    });
      case "NumberLiteral" :
          return JsxRuntime.jsx("input", {
                      className: ImportEnrichmentActionStyles$ReactHooksTemplate.inputBase,
                      placeholder: "e.g. 42",
                      type: "number",
                      value: row.valueLiteral,
                      onChange: (function (e) {
                          var newrecord = Caml_obj.obj_dup(row);
                          Curry._1(onUpdate, (newrecord.valueLiteral = e.target.value, newrecord));
                        })
                    });
      case "DateLiteral" :
          return JsxRuntime.jsx("input", {
                      className: ImportEnrichmentActionStyles$ReactHooksTemplate.inputBase,
                      type: "date",
                      value: row.valueLiteral,
                      onChange: (function (e) {
                          var newrecord = Caml_obj.obj_dup(row);
                          Curry._1(onUpdate, (newrecord.valueLiteral = e.target.value, newrecord));
                        })
                    });
      
    }
  };
  var match = row.valueType;
  switch (match) {
    case "Literal" :
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("label", {
                            children: "Value",
                            className: ImportEnrichmentActionStyles$ReactHooksTemplate.labelBase
                          }),
                      renderLiteralInput(),
                      JsxRuntime.jsx("p", {
                            children: "Enter the exact value to store when this rule runs.",
                            className: ImportEnrichmentActionStyles$ReactHooksTemplate.hintClass
                          })
                    ]
                  });
    case "CopyPath" :
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("label", {
                            children: "Copy from",
                            className: ImportEnrichmentActionStyles$ReactHooksTemplate.labelBase
                          }),
                      JsxRuntime.jsx(ImportEnrichmentFieldPicker$ReactHooksTemplate.make, {
                            fieldOptions: fieldOptions,
                            mode: "ReadablePath",
                            value: row.copyPath,
                            onChange: (function (v) {
                                var newrecord = Caml_obj.obj_dup(row);
                                Curry._1(onUpdate, (newrecord.copyPath = v, newrecord));
                              }),
                            placeholder: "Choose a source field"
                          }),
                      JsxRuntime.jsx("p", {
                            children: "Will copy \"" + ImportEnrichmentRuleTypes$ReactHooksTemplate.pathDisplayLabel(fieldOptions, row.copyPath) + "\" into \"" + ImportEnrichmentRuleTypes$ReactHooksTemplate.targetDisplayLabel(fieldOptions, row.targetKind, row.targetField) + "\".",
                            className: ImportEnrichmentActionStyles$ReactHooksTemplate.hintClass
                          })
                    ]
                  });
    case "LookupTable" :
        var match$1 = ImportEnrichmentActionHelpers$ReactHooksTemplate.literalInputKindForTarget(fieldOptions, row.targetKind, row.targetField);
        var tmp;
        var exit = 0;
        if (typeof match$1 !== "object") {
          tmp = JsxRuntime.jsx("input", {
                className: ImportEnrichmentActionStyles$ReactHooksTemplate.inputBase,
                placeholder: "Leave blank to skip when there is no match",
                value: row.lookupDefault,
                onChange: (function (e) {
                    var newrecord = Caml_obj.obj_dup(row);
                    Curry._1(onUpdate, (newrecord.lookupDefault = e.target.value, newrecord));
                  })
              });
        } else {
          exit = 1;
        }
        if (exit === 1) {
          tmp = JsxRuntime.jsxs("select", {
                children: [
                  JsxRuntime.jsx("option", {
                        children: "Leave blank",
                        value: ""
                      }),
                  Belt_Array.map(match$1._0, (function (option) {
                          return JsxRuntime.jsx("option", {
                                      children: option,
                                      value: option
                                    }, option);
                        }))
                ],
                className: ImportEnrichmentActionStyles$ReactHooksTemplate.selectBase,
                value: row.lookupDefault,
                onChange: (function (e) {
                    var newrecord = Caml_obj.obj_dup(row);
                    Curry._1(onUpdate, (newrecord.lookupDefault = e.target.value, newrecord));
                  })
              });
        }
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("label", {
                                            children: "When this field says…",
                                            className: ImportEnrichmentActionStyles$ReactHooksTemplate.labelBase
                                          }),
                                      JsxRuntime.jsx(ImportEnrichmentFieldPicker$ReactHooksTemplate.make, {
                                            fieldOptions: fieldOptions,
                                            mode: "ReadablePath",
                                            value: row.lookupPath,
                                            onChange: (function (v) {
                                                var newrecord = Caml_obj.obj_dup(row);
                                                Curry._1(onUpdate, (newrecord.lookupPath = v, newrecord));
                                              }),
                                            placeholder: "Choose a source field"
                                          })
                                    ]
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("label", {
                                            children: "If no match, use (optional)",
                                            className: ImportEnrichmentActionStyles$ReactHooksTemplate.labelBase
                                          }),
                                      tmp
                                    ]
                                  })
                            ],
                            className: "grid grid-cols-1 md:grid-cols-2 gap-4"
                          }),
                      JsxRuntime.jsx(ImportEnrichmentLookupMappingBuilder$ReactHooksTemplate.make, {
                            lookupMapText: row.lookupMapText,
                            sourcePath: row.lookupPath,
                            targetKind: row.targetKind,
                            targetField: row.targetField,
                            fieldOptions: fieldOptions,
                            onChange: (function (text) {
                                var newrecord = Caml_obj.obj_dup(row);
                                Curry._1(onUpdate, (newrecord.lookupMapText = text, newrecord));
                              })
                          })
                    ],
                    className: "space-y-4"
                  });
    case "RegexCapture" :
        return JsxRuntime.jsx(ImportEnrichmentExtractBuilder$ReactHooksTemplate.make, {
                    row: row,
                    fieldOptions: fieldOptions,
                    sampleValue: regexSample,
                    onUpdate: onUpdate
                  });
    case "DateDiffDays" :
        var preview = ImportEnrichmentActionHelpers$ReactHooksTemplate.dateDiffPreviewText(row.fromPath, row.toPath, simulationInputs);
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("label", {
                                            children: "Start date",
                                            className: ImportEnrichmentActionStyles$ReactHooksTemplate.labelBase
                                          }),
                                      JsxRuntime.jsx(ImportEnrichmentFieldPicker$ReactHooksTemplate.make, {
                                            fieldOptions: fieldOptions,
                                            mode: "ReadablePath",
                                            value: row.fromPath,
                                            onChange: (function (v) {
                                                var newrecord = Caml_obj.obj_dup(row);
                                                Curry._1(onUpdate, (newrecord.fromPath = v, newrecord));
                                              }),
                                            placeholder: "Choose a start date field"
                                          })
                                    ]
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("label", {
                                            children: "End date",
                                            className: ImportEnrichmentActionStyles$ReactHooksTemplate.labelBase
                                          }),
                                      JsxRuntime.jsx(ImportEnrichmentFieldPicker$ReactHooksTemplate.make, {
                                            fieldOptions: fieldOptions,
                                            mode: "ReadablePath",
                                            value: row.toPath,
                                            onChange: (function (v) {
                                                var newrecord = Caml_obj.obj_dup(row);
                                                Curry._1(onUpdate, (newrecord.toPath = v, newrecord));
                                              }),
                                            placeholder: "Choose an end date field"
                                          })
                                    ]
                                  })
                            ],
                            className: "grid grid-cols-1 md:grid-cols-2 gap-4"
                          }),
                      JsxRuntime.jsx("p", {
                            children: "This stores the number of whole days between the selected dates.",
                            className: ImportEnrichmentActionStyles$ReactHooksTemplate.hintClass
                          }),
                      preview !== undefined ? JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("p", {
                                      children: "Example result",
                                      className: "text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1"
                                    }),
                                JsxRuntime.jsx("p", {
                                      children: preview,
                                      className: "text-sm text-gray-800"
                                    })
                              ],
                              className: ImportEnrichmentActionStyles$ReactHooksTemplate.previewBoxClass
                            }) : null
                    ],
                    className: "space-y-3"
                  });
    case "Template" :
        return JsxRuntime.jsx(ImportEnrichmentTemplateBuilder$ReactHooksTemplate.make, {
                    templateText: row.templateText,
                    fieldOptions: fieldOptions,
                    onChange: (function (text) {
                        var newrecord = Caml_obj.obj_dup(row);
                        Curry._1(onUpdate, (newrecord.templateText = text, newrecord));
                      })
                  });
    
  }
}

var MethodInputs = {
  make: ImportEnrichmentActionForm$MethodInputs
};

function ImportEnrichmentActionForm(props) {
  var onRemove = props.onRemove;
  var onUpdate = props.onUpdate;
  var canRemove = props.canRemove;
  var fieldOptions = props.fieldOptions;
  var row = props.row;
  var primaryMethod = ImportEnrichmentRuleTypes$ReactHooksTemplate.primaryMethodForValueType(row.valueType);
  var showTransformMethods = ImportEnrichmentRuleTypes$ReactHooksTemplate.isTransformValueType(row.valueType);
  var match = React.useState(function (param) {
        return false;
      });
  var setMoreOptionsOpen = match[1];
  var moreOptionsOpen = match[0];
  var selectPrimary = function (method) {
    switch (method) {
      case "EnterValue" :
          var newrecord = Caml_obj.obj_dup(row);
          return Curry._1(onUpdate, (newrecord.valueType = "Literal", newrecord));
      case "CopyField" :
          var newrecord$1 = Caml_obj.obj_dup(row);
          return Curry._1(onUpdate, (newrecord$1.valueType = "CopyPath", newrecord$1));
      case "Transform" :
          if (!ImportEnrichmentRuleTypes$ReactHooksTemplate.isTransformValueType(row.valueType)) {
            var newrecord$2 = Caml_obj.obj_dup(row);
            Curry._1(onUpdate, (newrecord$2.valueType = "LookupTable", newrecord$2));
          }
          return Curry._1(setMoreOptionsOpen, (function (param) {
                        return false;
                      }));
      
    }
  };
  var selectTransform = function (valueType) {
    var newrecord = Caml_obj.obj_dup(row);
    Curry._1(onUpdate, (newrecord.valueType = valueType, newrecord));
    Curry._1(setMoreOptionsOpen, (function (param) {
            return false;
          }));
  };
  var summary = ImportEnrichmentRuleTypes$ReactHooksTemplate.buildActionSummary(fieldOptions, row);
  var groupName = "action-method-" + row.id;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: String(props.index + 1 | 0),
                              className: "inline-flex items-center justify-center w-7 h-7 rounded-full bg-lochmara text-white text-xs font-bold"
                            }),
                        JsxRuntime.jsx("button", {
                              children: "Remove action",
                              "aria-label": "Remove action",
                              className: "rounded-lg px-3 py-1.5 text-xs font-medium transition-colors " + (
                                canRemove ? "border border-red-200 text-firebrick hover:bg-lavenderblush" : "border border-gray-200 text-gray-400 cursor-not-allowed"
                              ),
                              disabled: !canRemove,
                              type: "button",
                              onClick: (function (param) {
                                  Curry._1(onRemove, undefined);
                                })
                            })
                      ],
                      className: "flex items-center justify-between gap-2 mb-4"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("label", {
                              children: "Update",
                              className: ImportEnrichmentActionStyles$ReactHooksTemplate.labelBase
                            }),
                        JsxRuntime.jsx(ImportEnrichmentFieldPicker$ReactHooksTemplate.make, {
                              fieldOptions: fieldOptions,
                              mode: "WritableTarget",
                              value: "",
                              placeholder: "Choose a field to update",
                              targetKind: row.targetKind,
                              targetField: row.targetField,
                              onTargetSelect: (function (kind, field) {
                                  var newrecord = Caml_obj.obj_dup(row);
                                  Curry._1(onUpdate, (newrecord.targetField = field, newrecord.targetKind = kind, newrecord));
                                })
                            }),
                        JsxRuntime.jsxs("label", {
                              children: [
                                JsxRuntime.jsx("input", {
                                      checked: row.onlyIfBlank,
                                      type: "checkbox",
                                      onChange: (function (e) {
                                          var newrecord = Caml_obj.obj_dup(row);
                                          Curry._1(onUpdate, (newrecord.onlyIfBlank = e.target.checked, newrecord));
                                        })
                                    }),
                                JsxRuntime.jsx("div", {
                                      className: "checkbox cursor-pointer"
                                    }),
                                JsxRuntime.jsx("span", {
                                      children: "Don't overwrite if this field already has a value",
                                      className: "ml-2"
                                    })
                              ],
                              className: "flex items-center text-xs mt-3 cursor-pointer text-gray-600"
                            })
                      ],
                      className: "mb-4"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                              children: "How should this field be set?",
                              className: "text-sm font-medium text-gray-700 mb-2"
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(ImportEnrichmentActionForm$MethodCard, {
                                      title: "Fixed value",
                                      description: ImportEnrichmentRuleTypes$ReactHooksTemplate.valueTypeDescription("Literal"),
                                      selected: primaryMethod === "EnterValue",
                                      onSelect: (function (param) {
                                          selectPrimary("EnterValue");
                                        }),
                                      name: groupName
                                    }),
                                JsxRuntime.jsx(ImportEnrichmentActionForm$MethodCard, {
                                      title: "Copy from another field",
                                      description: ImportEnrichmentRuleTypes$ReactHooksTemplate.valueTypeDescription("CopyPath"),
                                      selected: primaryMethod === "CopyField",
                                      onSelect: (function (param) {
                                          selectPrimary("CopyField");
                                        }),
                                      name: groupName
                                    }),
                                JsxRuntime.jsx(ImportEnrichmentActionForm$MethodCard, {
                                      title: "Calculate / Transform",
                                      description: ImportEnrichmentRuleTypes$ReactHooksTemplate.transformPrimaryDescription,
                                      selected: primaryMethod === "Transform",
                                      onSelect: (function (param) {
                                          selectPrimary("Transform");
                                        }),
                                      name: groupName
                                    })
                              ],
                              className: "grid grid-cols-1 md:grid-cols-3 gap-3"
                            })
                      ],
                      "aria-label": "How to set the field value",
                      className: "mb-4",
                      role: "radiogroup"
                    }),
                showTransformMethods ? null : JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("button", {
                                children: moreOptionsOpen ? "▾ More options" : "▸ More options",
                                "aria-label": "Toggle more transform options",
                                "aria-expanded": moreOptionsOpen,
                                className: "text-sm font-medium text-lochmara hover:text-blue-800 focus:outline-none focus:underline",
                                type: "button",
                                onClick: (function (param) {
                                    Curry._1(setMoreOptionsOpen, (function (prev) {
                                            return !prev;
                                          }));
                                  })
                              }),
                          moreOptionsOpen ? JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(ImportEnrichmentActionForm$TransformMethodPicker, {
                                        row: row,
                                        fieldOptions: fieldOptions,
                                        onSelect: selectTransform,
                                        groupName: groupName + "-advanced",
                                        title: "Advanced value methods"
                                      }),
                                  className: "mt-3"
                                }) : null
                        ],
                        className: "mb-4"
                      }),
                showTransformMethods ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx(ImportEnrichmentActionForm$TransformMethodPicker, {
                              row: row,
                              fieldOptions: fieldOptions,
                              onSelect: selectTransform,
                              groupName: groupName + "-transform",
                              title: "Transform method"
                            }),
                        className: "mb-4"
                      }) : null,
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ImportEnrichmentActionForm$MethodInputs, {
                            row: row,
                            fieldOptions: fieldOptions,
                            simulationInputs: props.simulationInputs,
                            onUpdate: onUpdate
                          }),
                      className: "pt-3 border-t border-gray-100"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("p", {
                              children: "Preview",
                              className: "text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1"
                            }),
                        JsxRuntime.jsx("p", {
                              children: summary,
                              "aria-live": "polite",
                              className: "text-sm text-gray-800 leading-snug"
                            })
                      ],
                      className: "mt-4 rounded-lg bg-antiflashwhite border border-gray-200 px-4 py-3"
                    })
              ],
              className: "border border-gray-200 rounded-xl p-4 bg-white shadow-sm" + (
                props.highlighted ? " ring-2 ring-blue-500" : ""
              )
            });
}

var make = ImportEnrichmentActionForm;

exports.transformCardClass = transformCardClass;
exports.methodCardClass = methodCardClass;
exports.MethodCard = MethodCard;
exports.TransformMethodCard = TransformMethodCard;
exports.TransformMethodPicker = TransformMethodPicker;
exports.MethodInputs = MethodInputs;
exports.make = make;
/* react Not a pure module */
